import { useForm } from "react-hook-form";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { Button, CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { clinicianId, clinicId } from "../../../constants";
import { useMutation } from "react-query";
import { getSickLeave } from "./services";
import usePrint from "../../../hooks/usePrint";

function SickLeaveForm() {
  const {encounterId} = useParams()
  const { control, handleSubmit,reset} = useForm();
  const {printPdf,loading} = usePrint()
  const {mutate,isLoading}=useMutation(getSickLeave,{onSuccess:(result)=>{
    if(result.responseIndicator == "success" && result.response){
      printPdf(result.response);
  };
  reset()}})

  const handleReset = ()=>{
    reset()
  }
  
  const onSubmit = (value: any) => {
    const params = {
      ...value,
      firstName: "",
      lastName: "",
      diag: "",
      encounterId: parseInt(encounterId as string),
      clinicId,
      clinicianId
    };
      mutate(params)    
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-3 gap-3">
      <CustomFormField
        control={control}
        element="datepicker"
        fieldProps={{ label: "From date" }}
        name="fromDate"
        rules={{ required: "From date required" }}
      />
      <CustomFormField
        control={control}
        element="datepicker"
        fieldProps={{ label: "To date" }}
        name="toDate"
        rules={{ required: "From date required" }}
      />

      <div className="flex gap-x-2  items-center">
      <Button type="submit" color="success"
        disabled={(isLoading|| loading)}
         endIcon={
            (isLoading|| loading) &&
            <CircularProgress size={20} />
        }
      >
        submit
      </Button>
        <Button color="error" onClick={handleReset}>reset</Button>
      </div>
    </form>
  );
}

export default SickLeaveForm;
